export const TAB_NAMES = {
  profile: 'Profile',
  transactions: 'Transactions'
};

export const TAB_HASH = {
  profile: '#profile',
  transactions: '#transactions'
};

export const TABS = [
  { name: TAB_NAMES.profile, icon: 'Settings', hash: TAB_HASH.profile },
  { name: TAB_NAMES.transactions, icon: 'Document', hash: TAB_HASH.transactions }
];
